import {useApi} from "~/composables/api/utils/useApi"

export const usePageApi = () => ({
  async getBySlug(slug, token = null) {
    const url = `pages?filter[slug]=${slug}`
    const api = useApi()

    try {
      const result = await api.makeRequest(url, 'get')
      return result?.length > 0 ? result[0] : null
    } catch (err) {
      throw err
    }
  }
})
